export const contacts = {
    instagramLink: "https://www.instagram.com/katia_depilacja/",
    instagramName: "@katia_depilacja",
    facebookLink: "https://www.facebook.com/profile.php?id=100085317653589",
    facebookName: "Kateryna Sugaring",
    phoneNumber: "(+48) 793 724 601",
    email: "me@sugaringkateryna.pl",
}

export const path = {
    home: "/",
    prices: "/prices",
    more: "/more",
}

export const url = "http://127.0.0.1:5500/sendemail";